// --------------------------------------------------------------------------
// modalContainer.js
// --------------------------------------------------------------------------
// Uses fancybox to create lightbox image gallery
// --------------------------------------------------------------------------

RN.modalContainer = function() {
    'use strict';
    var scrollPos = 0
    var body = document.body
    function init() {
        var trigger = byBehaviour('modal-trigger')
        var modalContainer = byBehaviour('modal-container')
        var nextStepButton = modalContainer.find(byBehaviour('next-step'))
        trigger.each(function () {
            this.dataset.enabled = this.dataset.enabled || 'false'
            if (this.dataset.enabled === 'true') {
                return
            }
            this.dataset.enabled = 'true'
            $(this).on('click', openModal)
        });

        nextStepButton.each(function () {
           this.dataset.enabled = this.dataset.enabled || 'false'
            if (this.dataset.enabled === 'true') {
                return
            }
            this.dataset.enabled = 'true'
            $(this).on('click', goToNextModal)
        })

    }

    function openModal(e) {
        var thisButton = this
        var target = byElement(thisButton.dataset.target)

        if (thisButton.dataset.target == "sign-in-modal") {
           // ensure any other modals are closed
           byElement('modal-step-2').removeClass('modal--active');
        }

        var activeClass = target.data('class')
        target.toggleClass(activeClass)
        var isModalOpen = target.hasClass(activeClass)
        toggleScroll(isModalOpen)
    }

    function goToNextModal(e) {
        var thisButton = this
        var currentModal = byBehaviour(thisButton.dataset.current)
        var currentModalCloseButton = $('.modal__close').filter('[data-target="'+ thisButton.dataset.current + '"]')

        currentModalCloseButton.trigger('click')

        if (thisButton.dataset.target == "end") {
            startScroll()
        }
        else {
            var target = byElement(thisButton.dataset.target)
            if (target.is(":hidden")) {
                startScroll()
            }
            else {
                var activeClass = target.data('class')
                target.toggleClass(activeClass)
                var isModalOpen = target.hasClass(activeClass)
                toggleScroll(isModalOpen)
            }
        }
    }

    function stopScroll() {
        scrollPos = $(window).scrollTop()
        body.style.height = window.outerHeight +'px'
        body.style.overflow = 'hidden'
        $('body').children().first().css({ marginTop: -scrollPos })
        $(window).scrollTop(0)
    }

    function startScroll() {
        body.style.height = null
        body.style.overflow = null
        $('body').children().first().css({ marginTop: 0 })
        $(window).scrollTop(scrollPos)
    }

    function toggleScroll(isModalOpen) {
        if (isModalOpen) {
            stopScroll()
        } else {
            startScroll()
        }
    }

    return {
        init: init
    };
}();
